import React from 'react';
import './App.css';

import Coordinates from './components/Coordinates/Coordinates';

import { BrowserRouter, Switch, Route } from 'react-router-dom';
import OuterLocation from './components/OuterLocation/OuterLocation';
import Landing from './components/Landing/Landing';
import DeliveryInstructions from './components/DeliveryInstructions/DeliveryInstructions';
import Success from './components/Success/Success';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route path="/currentLocation" exact component={Coordinates} />
          <Route path="/outerLocation" exact component={OuterLocation} />
          <Route path="/delivery" exact component={DeliveryInstructions} />
          <Route path="/success" exact component={Success} />
          <Route path="/" exact component={Landing} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;


// http://www.google.com/maps/place/27.673258,85.313816